import { atom, selector, useRecoilState } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

const crossSectionColorState = atom({
  key: 'crossSectionColorState',
  default: selector({
    key: 'crossSectionColorStateSelector',
    get: () => {
      return getCustomerSettings("mapConfig.CROSSSECTION_COLOR");
    }
  })
});

export const useCsColorState = () => {
  const [csColor, setCsColor] = useRecoilState(crossSectionColorState);

  const isLightCs = csColor === 'white';
  const isDarkCs = !isLightCs;

  const changeCsColorDark = ()=>{
    setCsColor('black');
  }
  const changeCsColorLight = () => {
    setCsColor('white');
  };

  return {
    csColor,
    isLightCs,
    isDarkCs,
    changeCsColorDark,
    changeCsColorLight
  }
}